import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { novels } from '@/mocks/novels';
import { formatCount } from '@/utils/format';
import SearchBox from '@/components/feature/SearchBox';

const featured = novels.filter((n) => n.featured);

export default function HeroCarousel() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setIndex((v) => (v + 1) % featured.length);
    }, 5500);
    return () => window.clearInterval(timer);
  }, []);

  const go = (next: number) => {
    setIndex((next + featured.length) % featured.length);
  };

  return (
    <section className="relative w-full overflow-hidden bg-gradient-to-br from-primary-100 via-background-50 to-accent-50">
      <div className="mx-auto w-full px-4 py-10 md:px-8 md:py-16">
        <div className="mx-auto mb-10 max-w-2xl text-center md:mb-14">
          <h1 className="font-brand text-3xl leading-tight text-primary-600 md:text-5xl">
            美丽的小蜜桃
          </h1>
          <p className="mt-3 text-sm text-foreground-600 md:text-base">
            热门小说在线阅读与章节更新 · 玄幻言情一站追更
          </p>
          <div className="mx-auto mt-6 max-w-xl">
            <SearchBox variant="hero" />
          </div>
        </div>

        <div className="relative">
          {featured.map((novel, i) => (
            <div
              key={novel.id}
              className={`transition-opacity duration-700 ${
                i === index ? 'opacity-100' : 'pointer-events-none absolute inset-0 opacity-0'
              }`}
            >
              <div className="flex flex-col items-center gap-8 lg:flex-row lg:items-center lg:gap-14">
                <div className="w-full lg:w-1/2">
                  <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-700">
                    <i className="ri-fire-fill"></i>
                    本站精选 · {novel.category}小说
                  </span>
                  <h2 className="mt-5 font-heading text-3xl font-bold leading-tight text-foreground-950 md:text-5xl">
                    {novel.title}
                  </h2>
                  <p className="mt-3 text-sm text-foreground-500">
                    作者：{novel.author} · {novel.status} · {novel.wordCount}
                  </p>
                  <p className="mt-5 max-w-xl text-sm leading-relaxed text-foreground-700 md:text-base">
                    {novel.intro}
                  </p>
                  <div className="mt-7 flex flex-wrap items-center gap-3">
                    <Link
                      to={`/detail/${novel.id}`}
                      className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
                    >
                      <i className="ri-book-read-line"></i>
                      立即阅读
                    </Link>
                    <span className="inline-flex items-center gap-1.5 text-sm text-foreground-500">
                      <i className="ri-star-fill text-accent-500"></i>
                      {novel.rating.toFixed(1)} 分 · {formatCount(novel.favorites)} 人收藏
                    </span>
                  </div>
                </div>

                <div className="w-full lg:w-1/2">
                  <div className="mx-auto flex max-w-md items-center justify-center">
                    <div className="relative">
                      <div className="absolute -left-6 top-6 h-full w-full rounded-xl bg-primary-200"></div>
                      <img
                        src={novel.cover}
                        alt={`${novel.title}封面`}
                        title={`${novel.title}小说封面`}
                        className="relative h-[380px] w-[272px] rounded-xl object-cover object-top shadow-md md:h-[440px] md:w-[314px]"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}

          <div className="mt-8 flex items-center justify-center gap-4">
            <button
              type="button"
              aria-label="上一本"
              onClick={() => go(index - 1)}
              className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full border border-background-300 bg-background-50 text-foreground-600 transition-colors hover:border-primary-400 hover:text-primary-600"
            >
              <i className="ri-arrow-left-s-line text-xl"></i>
            </button>
            <div className="flex items-center gap-2">
              {featured.map((novel, i) => (
                <button
                  key={novel.id}
                  type="button"
                  aria-label={`查看第 ${i + 1} 本精选`}
                  onClick={() => setIndex(i)}
                  className={`h-2 cursor-pointer rounded-full transition-all ${
                    i === index ? 'w-6 bg-primary-500' : 'w-2 bg-primary-200'
                  }`}
                ></button>
              ))}
            </div>
            <button
              type="button"
              aria-label="下一本"
              onClick={() => go(index + 1)}
              className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full border border-background-300 bg-background-50 text-foreground-600 transition-colors hover:border-primary-400 hover:text-primary-600"
            >
              <i className="ri-arrow-right-s-line text-xl"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}